import React from 'react';
import PropTypes from 'prop-types';
import './Input.scss';

const Input = ({ symbol, ...inputProps }) => (
    <div className="input-container">
        <span>{symbol}</span>
        <input {...inputProps}/>
    </div>
);

Input.propTypes = {
    symbol: PropTypes.string
};

export default Input;
